import { Tab, TabProps } from 'react-admin';
import Accidents from './Accidents';
import Actions from './Actions';
import Licenses from './Licenses';
import { Wrapper } from './styled';
import Violations from './Violations';

const MVRTab = (props: Partial<TabProps>) => (
  <Tab label="MVR" {...props}>
    <Wrapper>
      <Actions />
      <Accidents />
      <Violations />
      <Licenses />
    </Wrapper>
  </Tab>
);

export default MVRTab;
